import { PrivateAPINamespace } from '../PrivateAPINamespace';
export class UserPreferencesNamespace extends PrivateAPINamespace {
    set(appDefinitionId, preferences) {
        return this.ps.hostAPI.editor.userPreferences.set(appDefinitionId, preferences);
    }
    get(appDefinitionId, keys) {
        return this.ps.hostAPI.editor.userPreferences.get(appDefinitionId, keys);
    }
}
UserPreferencesNamespace.namespace = 'userPreferences';
//# sourceMappingURL=UserPreferencesNamespace.js.map